// extracted by mini-css-extract-plugin
export default {"inputs":"SectionForm_inputs__roaTa","actions":"SectionForm_actions__Rs694"};